import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin":"2%","font-weight":"bold"} }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table-transmission table-deductions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Fecha inicio"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha fin"),
  /*#__PURE__*/_createElementVNode("th", null, "Cantidad"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_5 = { class: "p-v-error error-transmission" }
const _hoisted_6 = { class: "p-v-error error-transmission" }
const _hoisted_7 = { class: "p-v-error error-transmission" }
const _hoisted_8 = { class: "tooltip-container" }
const _hoisted_9 = { class: "delete-row" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.AgregarFila && $setup.AgregarFila(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'plus-circle'],
          style: {"color":"#00805d"}
        }),
        _createTextVNode(" Adicionar ")
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.strikes.items, (strike, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _createVNode(_component_Calendar, {
                  modelValue: strike.StartDate,
                  "onUpdate:modelValue": ($event: any) => ((strike.StartDate) = $event),
                  onBlur: $setup.FormatearFechas,
                  class: "pv-input-size",
                  showButtonBar: "",
                  showSeconds: "",
                  dateFormat: "yy-mm-dd"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                  .StartDate, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_Calendar, {
                  modelValue: strike.EndDate,
                  "onUpdate:modelValue": ($event: any) => ((strike.EndDate) = $event),
                  onBlur: $setup.FormatearFechas,
                  class: "pv-input-size",
                  showButtonBar: "",
                  showSeconds: "",
                  dateFormat: "yy-mm-dd"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index].EndDate, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  min: 0,
                  inputId: "minmax-buttons",
                  mode: "decimal",
                  modelValue: strike.Quantity,
                  "onUpdate:modelValue": ($event: any) => ((strike.Quantity) = $event),
                  class: _normalizeClass(["pv-input-size input-number quantity", {
                'p-invalid':
                  $setup.v$.items.$each.$response.$errors[index].Quantity[0],
              }])
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                    .Quantity, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("a", {
                  onClick: ($event: any) => ($setup.EliminarHuelgaLegal(index))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'minus-circle'],
                    size: "lg"
                  })
                ], 8, _hoisted_10)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}